import { useEffect, useState } from "react";
import CommentBox from "../../../components/CommentBox/CommentBox";
import Header from "../../../components/SubtaskHeader/SubtaskHeader";
import './SubtaskScreens.css';
import { getViewTaskDocumentUrl } from "../../../../../utils/taskUtils";
import { HiOutlineExternalLink } from "react-icons/hi";

const DocumentLinks = ({ documentIds }) => {
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
        if (!documentIds?.length) return;

        const fetchDocuments = async () => {
            const results = await Promise.all(
                documentIds.map((id) => getViewTaskDocumentUrl({
                    document_id: id
                }))
            );

            console.log({ documentIds,  results });

            const formatted = results
                .filter(Boolean)
                .map((document, index) => ({
                    id: documentIds[index],
                    url: document?.document_url,
                }));

            setDocuments(formatted);
        };

        fetchDocuments();
    }, [documentIds]);

    if (!documents.length) return null;

    return (
        <div className="document-links">
            {documents?.map((doc, index) => (
                <div 
                    key={doc?.id}
                    className="document-link-container"
                >
                    <a
                        href={doc?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="document-link"
                    >
                        View Document
                        <HiOutlineExternalLink />
                    </a>
                </div>
            ))}
        </div>
    );
};

const FieldSubtask = ({ subtask }) => {
    console.log({ subtask });
    const category = subtask.category;
    const type = category?.meta_data?.typeOf;

    let actualAndExpectedData = subtask?.actual_and_expected_data;
    let categoryMetaData = subtask.category?.meta_data;
    // console.log({ actualAndExpectedData });

    const renderValue = (value, type, meta, dbTableName) => {
        if (value === null || value === undefined || value === "") {
            return <span className="empty-value">—</span>;
        }

        console.log({ typeOf: type});

        // /* ===== OBJECT TYPE (WITH DOCUMENTS) ===== */
        // if (typeof value === "object" && !Array.isArray(value)) {
        //     const documentIds = [];

        //     if (Array.isArray(value.document_ids)) {
        //         documentIds.push(...value.document_ids);
        //     }

        //     if (value.document_id) {
        //         documentIds.push(value.document_id);
        //     }

        //     return (
        //         <div className="object-value-container">
        //             {/* Render non-document fields */}
        //             {Object.entries(value)
        //                 .filter(
        //                     ([key]) =>
        //                         key !== "document_id" &&
        //                         key !== "document_ids"
        //                 )
        //                 .map(([key, val]) => (
        //                     <div key={key}>
        //                         <strong>
        //                             {key.replace(/_/g, " ")}:
        //                         </strong>{" "}
        //                         {String(val)}
        //                     </div>
        //                 ))}

        //             {/* Render documents */}
        //             <DocumentLinks documentIds={documentIds} />
        //         </div>
        //     );
        // }

        switch (type) {
            case "json":
            case "stock":
            case "map":
                try {
                    const parsed = typeof value === "string" ? JSON.parse(value) : value;

                    
                    const documentIds = [];
                    
                    if (Array.isArray(parsed.document_ids)) {
                        documentIds.push(...parsed.document_ids);
                    }
                    
                    if (parsed.document_id) {
                        documentIds.push(parsed.document_id);
                    }
                    console.log({ parsed, documentIds });

                    return (
                        // <div className="json-container">
                        //     {Object.entries(parsed).map(([key, val]) => (
                        //         <div key={key} className="json-row">
                        //             <strong>{key.replace(/_/g, " ")}:</strong> {String(val)}
                        //         </div>
                        //     ))}
                        // </div>
                        <>
                        <pre className="json-pretty">
                            {JSON.stringify(parsed, null, 2)}
                        </pre>

                        {/* Render documents */}
                        <DocumentLinks documentIds={documentIds} /> 
                        </>
                    );
                } catch (err) {
                    return <span>{String(value)}</span>;
                }

            case "array":
                // const arr = Array.isArray(value)
                //     ? value
                //     // : typeof value === "string"
                //     // ? JSON.parse(value)
                //     : [];

                // return (
                //     <span className="array-list">{arr?.join(", ")}</span>
                //     // <ul className="array-list">
                //     //     {arr.map((item, index) => (
                //     //         <li key={index}>{String(item)}</li>
                //     //     ))}
                //     // </ul>
                // );

                // If multiple select true → real array
                if (meta?.multiple_select) {
                    if (Array.isArray(value)) {
                        return value.join(", ");
                    }
                    if (typeof value === "string") {
                        return value;
                    }
                    return "-";
                }

                // If single select (like Yes/No)
                if (typeof value === "boolean") {
                    return value ? "Yes" : "No";
                }

                if (typeof value === "string") {
                    if (dbTableName === "BmPrimaryQuestions" || dbTableName === "BcmPrimaryQuestions" || dbTableName === "ExcessManagementApproval")
                        return value === "true" ? "Yes" : value === "false" ? "No" : value;
                    return value;
                }

                return "-";

            case "date":
                const date = new Date(value);
                return <span>{date.toLocaleDateString()}</span>;

            case "boolean":
                return (
                    <span className={value ? "bool-true" : "bool-false"}>
                        {value ? "Yes" : "No"}
                    </span>
                );

            case "string":
            case "pincode":
            default:
                return <span>{String(value)}</span>;
        }
    };


    return (
        <div className={`subtask-card status-${subtask?.status?.status_code?.toLowerCase()}`}>
            <Header subtask={subtask} />

            <div className="field-compare">
                <div className="original">
                    <label>Original Value</label>
                    {/* <p>{category?.original_value}</p> */}
                    {/* <span>{actualAndExpectedData?.previous_value}</span> */}
                     {renderValue(actualAndExpectedData?.previous_value, type, categoryMetaData, actualAndExpectedData?.dbTableName)}
                </div>

                <div className="corrected">
                    <label>Corrected Value</label>
                    {/* <p>{category?.corrected_value}</p> */}
                    {/* <span>{category?.updated_value}</span> */}
                    {/* <span>{actualAndExpectedData?.updated_value}</span> */}
                    {renderValue(actualAndExpectedData?.updated_value, type, categoryMetaData, actualAndExpectedData?.dbTableName)}
                </div>
            </div>

            <CommentBox subtask={subtask} />
        </div>
    );
};

export default FieldSubtask;
